import { useQuery } from 'urql';

import { AddressSavingsDocument } from '~src/graphql';
import { deepNullToUndefined } from '~src/util';

export const useAddressSavings = (dawaId?: string) => {
  const [result] = useQuery({
    query: AddressSavingsDocument,
    variables: { dawaId: dawaId! },
    pause: !dawaId,
  });

  return {
    data: deepNullToUndefined(result.data?.addressSavings),
    fetching: result.fetching,
  };
};
